module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av616-8c4382485b97b608c0db9256a4e3ac62.jpg";